import getActionsByDocument from '../../../../../components/comments/actions';

const DOCUMENT = 'CLIENT_COMMENTS_';

export default getActionsByDocument(DOCUMENT);
